<div class="header_page__sidenav" *ngIf="showSideNav" (click)="showSideNav = false">
  <div class="header_page__sidenav__menu" [class.menu-for-profile]="!is_student && profile">
    <ng-container *ngIf="is_teacher || is_teacher_helper || is_metodist || is_navigator || is_navigator_junior || is_super_navigator">
      <a *ngFor="let navLink of links" class="header_page__sidenav__menu__item"
           [routerLinkActive]="'active'"
           [routerLink]="navLink.link">
        <span><img src="{{ navLink.imgUrl }}" alt=""></span>
        <span>{{ navLink.label }}</span>
      </a>
    </ng-container>
    <ng-container *ngIf="is_student">
      <a class="header_page__sidenav__menu__item"
         routerLinkActive="item_active"
         (click)="openNavUrl('/profile/results/lessons/0')">Результаты</a>
      <a class="header_page__sidenav__menu__item"
         routerLinkActive="item_active"
         (click)="openNavUrl('/profile/awards')">Награды</a>
      <a class="header_page__sidenav__menu__item"
         routerLinkActive="item_active"
         (click)="openNavUrl('/profile/purchases')">Покупки</a>
    </ng-container>
  </div>
</div>
<section class="header-wrapper" [class.student-nav]="is_student">
  <header id="header-panel" class="header_page">
    <div class="main-logo logo-for-profile" [routerLink]="[APP_PATH.home]" *ngIf="!is_student && profile">
      <span><img src="/assets/images/new-logo.png" alt="Smartup school"></span>
    </div>
    <div class="main-logo" [routerLink]="[APP_PATH.home]" *ngIf="!profile">
      <span><img src="/assets/images/new-logo.png" alt="Smartup school"></span>
    </div>
    <div class="main-logo logo-for-student" [routerLink]="[APP_PATH.home]" *ngIf="is_student">
      <span><img src="/assets/images/logo_white.svg" alt="Smartup school"></span>
    </div>

    <div class="header_page__toogle-nav" *ngIf="profile">
      <mat-icon [class.for-student]="is_student" [class.for-other-profile]="!is_student && profile"
                (click)="showSideNav = true">dehaze</mat-icon>
    </div>
    <div *ngIf="isShowButtonLesson" class="lesson__button">
      <button (click)="openLessonDialog()">К БОКСАМ!</button>
    </div>
    <div *ngIf="is_teacher || is_teacher_helper || is_metodist || is_navigator || is_navigator_junior || is_super_navigator"
         class="header_page__main-menu">
      <div *ngFor="let navLink of links" class="navigation-box"
           [routerLinkActive]="'active'"
           [routerLink]="navLink.link">
        <span><img src="{{ navLink.imgUrl }}" alt=""></span>
        <span>{{ navLink.label }}</span>
      </div>
    </div>
    <div *ngIf="is_student" class="header_page__student-menu">
      <a class="header_page__student-menu__item"
         routerLinkActive="item_active"
         [routerLink]="['/profile/results/lessons/0']">Результаты</a>
      <a class="header_page__student-menu__item"
         routerLinkActive="item_active"
         [routerLink]="['/profile/awards/'+ profile.user.id]">Награды</a>
      <a class="header_page__student-menu__item"
         routerLinkActive="item_active"
         [routerLink]="['/profile/purchases']">Покупки</a>
    </div>
    <div class="header_page__right-colum">
      <div class="header_page__services">
        <div *ngIf="profile && !is_student" class="notifications">
          <a (click)="showNotifications()" routerLinkActive="item_active">
            <mat-icon *ngIf="!countNewNotifications" class="notifications__icon">notifications</mat-icon>
            <mat-icon *ngIf="countNewNotifications" class="notifications__icon" [matBadge]="countNewNotifications" matBadgeColor="warn">notifications</mat-icon>
          </a>
        </div>
        <div *ngIf="!is_student && !is_parent" class="apps">
          <div class="apps__trigger" [matMenuTriggerFor]="apps">
            <mat-icon>apps</mat-icon>
          </div>
          <mat-menu class="apps__menu" #apps="matMenu">
            <a [disabled]="!canTournaments()" mat-menu-item target="_blank" href="http://94.198.221.196:8889">
              <span>Турниры</span>
            </a>
            <a *ngIf="isReportAccess" mat-menu-item [routerLink]="['/reports']">
              <span>Отчеты</span>
            </a>
          </mat-menu>
        </div>
      </div>

      <div *ngIf="profile" class="profile">
        <div *ngIf="is_student" class="profile__student_money" (click)="openNavUrl('/profile/bank')">
          <span><img src="/assets/images/Vector.svg" alt="$"></span>
          <span class="profile__student_money__count">{{ student_amount }}</span>
        </div>
        <div class="profile__trigger" [matMenuTriggerFor]="menu">
          <div class="user-icon" *ngIf="userPhoto">
            <img class="user-icon__photo" src="{{ userPhoto }}" [alt]="initials">
          </div>
          <div class="user-icon user-not_img" *ngIf="!userPhoto">
            {{ initials }}
          </div>
        </div>
        <mat-menu #menu="matMenu">
          <a mat-menu-item [routerLink]="[APP_PATH.profile.settings.profile]">
            <mat-icon>settings</mat-icon>
            <span>Настройки</span>
          </a>
          <a mat-menu-item (click)="logout($event)">
            <mat-icon>exit_to_app</mat-icon>
            <span>Выйти</span>
          </a>
        </mat-menu>
      </div>

      <div class="signin" *ngIf="!profile">
        <button mat-button [routerLink]="['/login']">
          <mat-icon>person</mat-icon>
          <span> Войти</span>
        </button>
      </div>
    </div>
  </header>
</section>

<ng-template #openLessonMsg>
  <mat-dialog-content>
    <div class="open-lesson__modal">
      <span class="open-lesson__modal__close-icon">
        <mat-icon (click)="closeDialog()">close</mat-icon>
      </span>
      <span class="open-lesson__modal__title">
        Боксы открыты!
      </span>
      <span>
        <img src="/assets/images/ребята.png" alt="">
      </span>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <span class="lesson__button button-modal">
      <button mat-raised-button (click)="openLesson()">ВПЕРЕД!</button>
    </span>
  </mat-dialog-actions>
</ng-template>
